import { createReceiver } from '@/plugins/resource/resource'
import { friendlyUrlGenerator } from '@/packages/vue-friendly'
import { baseResource } from '@aspectus/resource'
import { prefixAPI, urlConstructor } from '@/plugins/resource/api'
import { prefixLanguage } from '@/utils/urls'

// Models
const MODEL = 'doctors'

export const DOCTORS_CATALOG_URL = prefixLanguage(`/catalog/${MODEL}/`)
export const DOCTORS_CATALOG_MAP_LIST_URL = `/catalog/${MODEL}/`

export const DOCTORS_MAP_LIST_URL = prefixAPI('/map/list/', 'doctor')

export const DOCTORS_FILTERS_URL = urlConstructor(`doctor/catalog/filters/`, [])

// filter resources
export const doctorsCatalogResource = friendlyUrlGenerator([
  DOCTORS_CATALOG_URL, 'ajax'
], baseResource)
export const doctorsMapListResource = friendlyUrlGenerator([
  DOCTORS_MAP_LIST_URL, 'filters/'
], baseResource)

export const doctorsFiltersResource = createReceiver(DOCTORS_FILTERS_URL)
